import { LeaveRequestApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { CreateLeaveRequestDto } from '../../../commonTypes/leaveRequest.types';
import { ICallback } from '../../../commonTypes/hook.types';
import { useTranslation } from '../../useTranslation';

const useHttpSubmitLeaveRequest = () => {
    const { t } = useTranslation('newNotifications');
    const leaveRequestApi = useContainer(LeaveRequestApi);
    const toastHandler = useContainer(ToastStateHandler);

    const createLeaveRequest = (body: CreateLeaveRequestDto, callback: ICallback) => {
        const { exec, clearCache, abort } = leaveRequestApi.submitLeaveRequest({
            body,
            onSuccess: res => {
                if (callback.onSuccess) callback.onSuccess(res.body);
                toastHandler.push('success', t('leaveRequest.leaveRequest'), t('leaveRequest.success'));
                clearCache();
            },
            onError: err => {
                if (err === 'Not carried over.') {
                    toastHandler.push('error', t('leaveRequest.submitFailedTitle'), t('leaveRequest.notCarriedOver'));
                } else {
                    toastHandler.push('error', t('leaveRequest.submitFailedTitle'), t('leaveRequest.submitFailedError'));
                }
            },
        });
        exec();
        return abort;
    };

    return { createLeaveRequest };
};

export default useHttpSubmitLeaveRequest;
